import { Component } from '@angular/core';

@Component({
  selector: 'app-students',
  template: `<router-outlet></router-outlet>`,
})
export class StudentsComponent {
  constructor() { }
}
